import * as React from 'react'
import { Link, withPrefix } from 'gatsby';
import { withoutPrefix } from '../../utilities/without-prefix';

// Added noopener manually
/* eslint-disable react/jsx-no-target-blank */
const Anchor = ({href, children, ...props}) => {
    const isExternal = React.useMemo(() => !href || href.startsWith(`//`) || href.indexOf(`://`) > 0 || href.startsWith(withPrefix('assets')) || href.startsWith(`#`), [href])
    
    const isHash = React.useMemo(() => href && href.startsWith(`#`), [href]);

    const unprefixedHref = React.useMemo(() => {
        if (isExternal) {
            return href;
        }

        const unprefixed = withoutPrefix(href);
        const parts = unprefixed.split('?');
        parts[0] = parts[0].toLowerCase();
        const result = parts.join('?');
        return result;
    },[href, isExternal])

    return (isExternal? <a href={href} target={isHash ? null : '_blank'} rel='noopener' {...props}>{children}</a> : <Link to={unprefixedHref} {...props}>{children}</Link>);
}

export default Anchor;